// MUI
import { Box, keyframes } from '@mui/material';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#0E1720",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="img"
        src="/logo.png"
        alt="Logo"
        sx={{ width: 120, height: 120, animation: `${pulse} 1.5s ease-in-out infinite`, }}
      />
    </Box>
  );
};

export { LoadingScreen };